'use client';

/**
 * Full-width "Continue with Google" button.
 *
 * Performs a top-level redirect to GET /api/v1/auth/google (NOT a fetch
 * — auth-google.json:91 spells this out explicitly: the backend writes
 * Redis state and returns a 302 that requires browser navigation).
 */
import { Button } from '@/components/ui';
import { googleSignInUrl } from '@/lib/auth';

interface GoogleSignInButtonProps {
  label?: string;
}

export function GoogleSignInButton({ label = 'Continue with Google' }: GoogleSignInButtonProps) {
  function onClick(): void {
    try {
      window.location.href = googleSignInUrl();
    } catch (err) {
       
      alert(err instanceof Error ? err.message : 'Google sign-in is unavailable');
    }
  }

  return (
    <Button fullWidth leftIcon={GoogleIcon} size="lg" variant="secondary" onClick={onClick}>
      {label}
    </Button>
  );
}

function GoogleIcon({ size = 18 }: { size?: number }) {
  return (
    <svg aria-hidden height={size} viewBox="0 0 24 24" width={size}>
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09Z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.24 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.11A6.6 6.6 0 0 1 5.5 12c0-.74.13-1.45.34-2.11V7.05H2.18A11 11 0 0 0 1 12c0 1.78.43 3.46 1.18 4.95l3.66-2.84Z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.61 0 3.06.55 4.2 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38Z"
        fill="#EA4335"
      />
    </svg>
  );
}
